export const desktopConfirm = {
  data() {
    return {
      showConfirmDialog: false,
      message: '',
      callback: () => {}
    }
  },
  methods: {
    showConfirm(msg, cb) {
      this.message = msg
      this.callback = cb
      this.showConfirmDialog = true
    }
  }
}
